import { render, staticRenderFns } from "./HomeComp.vue?vue&type=template&id=5b99adac&scoped=true&"
import script from "./HomeComp.vue?vue&type=script&lang=js&"
export * from "./HomeComp.vue?vue&type=script&lang=js&"
import style0 from "../assets/scss/home.scss?vue&type=style&index=0&id=5b99adac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b99adac",
  null
  
)

export default component.exports